import { Model } from 'json-api-models';

import type { Models, Schemas } from '../models.ts';

export class Video extends Model<Schemas['videos'], Models> {}
